import { createSlice } from "@reduxjs/toolkit";

export const userSlice = createSlice({
  name: "userData",
  initialState: {
    isUserLoggedIn: false,
    userEmail: null,
    userName: null,
    profileImage: null,
    userId: null,
    requiresSsoLogin: null,
    organization: {
      _id: null,
      name: null,
    },
  },
  reducers: {
    setUserLoggedIn: (state, action) => {
      if (action.payload === false) {
        state.userEmail = null;
        state.userName = null;
        state.profileImage = null;
      }
      state.isUserLoggedIn = action.payload;
    },
    setUserName: (state, action) => {
      state.userName = action.payload;
    },
    updateUserData: (state, action) => {
      const newState = {
        ...state,
        ...action.payload,
      };

      Object.assign(state, newState);
    },
  },
});

// Action creators are generated for each case reducer function
export const { setUserLoggedIn, setUserName, updateUserData } =
  userSlice.actions;

export default userSlice.reducer;
